import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35c66e3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "columns is-multiline" }
const _hoisted_6 = { class: "title is-4" }
const _hoisted_7 = {
  key: 0,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_8 = {
  key: 0,
  class: "field"
}
const _hoisted_9 = { class: "columns is-mobile is-align-items-center is-gapless" }
const _hoisted_10 = { class: "column is-narrow" }
const _hoisted_11 = { class: "label mr-2" }
const _hoisted_12 = { class: "column is-flex is-align-items-center" }
const _hoisted_13 = { class: "column is-narrow" }
const _hoisted_14 = { class: "column is-narrow" }
const _hoisted_15 = {
  key: 0,
  class: "help is-danger input-error"
}
const _hoisted_16 = {
  key: 1,
  class: "help is-success input-success"
}
const _hoisted_17 = {
  key: 1,
  class: "field is-flex is-align-items-center"
}
const _hoisted_18 = { class: "label mt-0 mr-2" }
const _hoisted_19 = {
  key: 0,
  class: "control is-flex-grow-1"
}
const _hoisted_20 = { class: "select is-fullwidth" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "label mt-4" }
const _hoisted_26 = { class: "control" }
const _hoisted_27 = {
  key: 3,
  class: "field"
}
const _hoisted_28 = { class: "label mt-0" }
const _hoisted_29 = { class: "control" }
const _hoisted_30 = ["placeholder", "disabled"]
const _hoisted_31 = { key: 4 }
const _hoisted_32 = { class: "label mt-4" }
const _hoisted_33 = { class: "control mb-4" }
const _hoisted_34 = {
  key: 5,
  class: "field"
}
const _hoisted_35 = { class: "field is-flex is-align-items-center" }
const _hoisted_36 = { class: "label mt-3 mr-2" }
const _hoisted_37 = { class: "control is-flex-grow-1" }
const _hoisted_38 = { class: "ml-2" }
const _hoisted_39 = ["data-tooltip"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle has-text-success" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "label mt-3" }
const _hoisted_43 = { class: "control" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 0,
  class: "is-hidden-desktop my-4 card p-2"
}
const _hoisted_47 = { class: "px-3 py-3 is-size-5 has-text-weight-semibold" }
const _hoisted_48 = { class: "is-flex" }
const _hoisted_49 = { class: "is-flex-grow-1" }
const _hoisted_50 = { class: "image is-128x128" }
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "subtitle is-flex is-flex-direction-column is-justify-content-center" }
const _hoisted_53 = { class: "is-size-6 has-text-weight-semibold has-text-grey-dark" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "checkbox mt-0" }
const _hoisted_56 = ["href"]
const _hoisted_57 = ["href"]
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "checkbox mt-0" }
const _hoisted_60 = ["href"]
const _hoisted_61 = {
  key: 8,
  class: "has-text-centered"
}
const _hoisted_62 = ["disabled"]
const _hoisted_63 = ["action"]
const _hoisted_64 = ["value"]
const _hoisted_65 = {
  key: 1,
  class: "field mt-4"
}
const _hoisted_66 = { class: "label" }
const _hoisted_67 = {
  key: 2,
  class: "card"
}
const _hoisted_68 = { class: "is-flex is-align-items-center" }
const _hoisted_69 = { class: "image is-128x128" }
const _hoisted_70 = ["src"]
const _hoisted_71 = { class: "is-flex is-flex-direction-column" }
const _hoisted_72 = { class: "is-size-5 has-text-grey-dark" }
const _hoisted_73 = {
  key: 3,
  class: "has-text-centered mt-4"
}
const _hoisted_74 = ["disabled"]
const _hoisted_75 = {
  key: 0,
  class: "image mb-1 mx-auto",
  style: {"width":"80%","height":"auto"}
}
const _hoisted_76 = ["src"]
const _hoisted_77 = {
  key: 1,
  class: "card is-hidden-mobile",
  style: {"max-width":"500px","margin":"0 auto"}
}
const _hoisted_78 = { class: "card-header mt-0 mb-0 px-2 py-1 is-size-5 has-text-weight-bold" }
const _hoisted_79 = { class: "card-header-title" }
const _hoisted_80 = { class: "card-content is-flex is-align-items-center mt-0 mb-0 py-1 px-2" }
const _hoisted_81 = { class: "media" }
const _hoisted_82 = { class: "media-left" }
const _hoisted_83 = { class: "image is-128x128 mt-0 mb-1 py-1 px-0" }
const _hoisted_84 = ["src"]
const _hoisted_85 = { class: "media-content mt-0 mb-1" }
const _hoisted_86 = { class: "title is-5 py-1 px-1" }
const _hoisted_87 = { class: "subtitle is-6 py-1 px-1" }
const _hoisted_88 = { key: 2 }
const _hoisted_89 = {
  key: 0,
  class: "scheduler-container is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_90 = { class: "image-container" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/uA3fRLZ.png",
    class: "image is-fullwidth",
    alt: "logo"
  })
], -1))
const _hoisted_92 = { class: "is-flex is-flex-direction-column is-justify-content-center" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("progress", { class: "progress is-primary" }, null, -1))
const _hoisted_94 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'column': true, 'is-6': !_ctx.getSchedulingAppointment, 'is-4': _ctx.getSchedulingAppointment, 'is-full-mobile': true })
              }, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('Customer.VideoAppointment')), 1),
                (!_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_7, _toDisplayString(_ctx.$t('Customer.TalkFavoriteVet')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("form", {
                  class: "column is-flex is-flex-direction-column is-justify-content-center",
                  onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scheduleAppointment && _ctx.scheduleAppointment(...args)), ["prevent"]))
                }, [
                  (_ctx.useAppointsAccessCodes && !_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('Customer.EnterAppointmentsAccessCode')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "input mr-2",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.appointmentCode) = $event)),
                              required: ""
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.appointmentCode,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitCode && _ctx.submitCode(...args))),
                              class: "button is-small is-primary mr-2"
                            }, _toDisplayString(_ctx.$t('Customer.SubmitCode')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            (_ctx.codeValidationError)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t('Customer.InvalidAccessCode')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.isCodeValid)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('Customer.ValidAccessCode')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('Customer.PetName')), 1),
                        (_ctx.getCustomerHasPets)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.appointment_pet_id) = $event)),
                                  required: "",
                                  class: "px-6"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEditedCustomerPets, (pet) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: pet.pet_id,
                                      value: pet.pet_id
                                    }, _toDisplayString(pet.name), 9, _hoisted_21))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.appointment_pet_id]
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("div", {
                                class: "notification is-danger is-light is-small",
                                innerHTML: _ctx.$t('CustomerData.PleaseAddPets'),
                                style: {"padding":"0.5rem","margin":"0.5rem 0"}
                              }, null, 8, _hoisted_23)
                            ]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('Customer.PetName')), 1),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.selectedPetName), 1)
                        ])
                      ])),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('Customer.ChiefComplaint')), 1),
                        _createElementVNode("div", _hoisted_29, [
                          _withDirectives(_createElementVNode("textarea", {
                            class: "textarea",
                            placeholder: _ctx.$t('Customer.DescChiefComplaint'),
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event)),
                            required: "",
                            disabled: !_ctx.getCustomerHasPets
                          }, null, 8, _hoisted_30), [
                            [
                              _vModelText,
                              _ctx.description,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('Customer.ChiefComplaint')), 1),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.description), 1)
                        ])
                      ])),
                  _createVNode(_component_FileInput, {
                    ref: "fileInput",
                    onFileChange: _ctx.handleFileUpload,
                    disabled: _ctx.isLoadingPaymentForm
                  }, null, 8, ["onFileChange", "disabled"]),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('Customer.SelectSchedulingDate')), 1),
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_VueDatePicker, {
                              id: "scheduling_date",
                              modelValue: _ctx.schedulingDate,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.schedulingDate) = $event)),
                              placeholder: _ctx.$t('General.PleaseSelectDate'),
                              "model-type": "yyyy-MM-dd",
                              "auto-apply": "",
                              "min-date": new Date(),
                              "max-date": _ctx.maxDate,
                              "enable-time-picker": false,
                              "prevent-min-max-navigation": "",
                              format: "yyyy-MM-dd"
                            }, null, 8, ["modelValue", "placeholder", "min-date", "max-date"])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("span", {
                              class: "icon has-tooltip-arrow has-tooltip-right",
                              "data-tooltip": _ctx.$t('Customer.SchedulingDateHelp')
                            }, _hoisted_41, 8, _hoisted_39)
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('Customer.SelectVetSpecialist')), 1),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["select is-fullwidth", { 'is-loading': _ctx.vetsListLoading }])
                          }, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.appointment_vet_user_id) = $event)),
                              required: "",
                              class: "px-6",
                              disabled: !_ctx.getCustomerHasPets,
                              onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.checkAvailableVets && _ctx.checkAvailableVets(...args)))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableVets, (vet) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: vet.user_id,
                                  value: vet.user_id
                                }, _toDisplayString(vet.name), 9, _hoisted_45))
                              }), 128))
                            ], 40, _hoisted_44), [
                              [_vModelSelect, _ctx.appointment_vet_user_id]
                            ])
                          ], 2)
                        ]),
                        (_ctx.appointment_vet_user_id > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('Customer.ImYourSpecialist')), 1),
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("figure", _hoisted_50, [
                                    _createElementVNode("img", {
                                      class: "is-rounded",
                                      src: _ctx.specialistProfileImageURL,
                                      alt: "no_profile_image"
                                    }, null, 8, _hoisted_51)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.requestedVetData[0].name), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 6,
                        class: "field",
                        disabled: !_ctx.getCustomerHasPets
                      }, [
                        _createElementVNode("label", _hoisted_55, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.gdprChecked) = $event)),
                            required: ""
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.gdprChecked]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Customer.GDPRPrev')) + " ", 1),
                          _createElementVNode("a", {
                            href: _ctx.gdprTermsUrl,
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t('Customer.GDPRLink')), 9, _hoisted_56),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Customer.TermsPrev')) + " ", 1),
                          _createElementVNode("a", {
                            href: _ctx.termsUrl,
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t('Customer.TermsLink')), 9, _hoisted_57)
                        ])
                      ], 8, _hoisted_54))
                    : _createCommentVNode("", true),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 7,
                        class: "field",
                        disabled: !_ctx.getCustomerHasPets
                      }, [
                        _createElementVNode("label", _hoisted_59, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.telemedicineAuthChecked) = $event)),
                            required: ""
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.telemedicineAuthChecked]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Customer.TelemedicineAuthPrev')) + " ", 1),
                          _createElementVNode("a", {
                            href: _ctx.authPrevUrl,
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t('Customer.TelemedicineAuthLink')), 9, _hoisted_60),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Customer.TelemedicineAuthNext')), 1)
                        ])
                      ], 8, _hoisted_58))
                    : _createCommentVNode("", true),
                  (!_ctx.getSchedulingAppointment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.isCreatingAppointment }]),
                          disabled: !_ctx.gdprChecked || !_ctx.telemedicineAuthChecked || !_ctx.getCustomerHasPets ||
                                           (_ctx.useAppointsAccessCodes && !_ctx.isCodeValid)
                        }, _toDisplayString(_ctx.$t('Customer.ScheduleAppointment')), 11, _hoisted_62)
                      ]))
                    : _createCommentVNode("", true)
                ], 32),
                _createElementVNode("form", {
                  class: "hidden",
                  action: _ctx.getPaymentEndpoint(),
                  method: "POST",
                  id: "paymentForm"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    name: "payment_hash",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.paymentHash) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.paymentHash]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    name: "payment_email",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.paymentEmail) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.paymentEmail]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    name: "customer_user_id",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customerUserId) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.customerUserId]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    name: "auth_token",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.authToken) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.authToken]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    name: "ga_client_id",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.gaClientId) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.gaClientId]
                  ]),
                  _createElementVNode("input", {
                    type: "hidden",
                    name: "appointment_included",
                    value: _ctx.isAppointmentIncluded ? '1' : '0'
                  }, null, 8, _hoisted_64)
                ], 8, _hoisted_63),
                (_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                      _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t('Customer.VetSpecialist')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("figure", _hoisted_69, [
                          _createElementVNode("img", {
                            class: "is-rounded",
                            src: _ctx.specialistProfileImageURL,
                            alt: "no_profile_image"
                          }, null, 8, _hoisted_70)
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.requestedVetData[0].name), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                      _createElementVNode("button", {
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.endScheduleAppointment && _ctx.endScheduleAppointment(...args))),
                        class: "button is-primary",
                        disabled: _ctx.isLoadingPaymentForm
                      }, _toDisplayString(_ctx.$t('General.Back')), 9, _hoisted_74)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass({ 'column': true, 'is-hidden-mobile': !_ctx.getSchedulingAppointment, 'is-6': !_ctx.getSchedulingAppointment, 'is-8': _ctx.getSchedulingAppointment, 'is-flex': true, 'is-flex-direction-column': true, 'is-align-items-center': true })
              }, [
                (!_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("figure", _hoisted_75, [
                      _createElementVNode("img", {
                        src: _ctx.imagePath,
                        alt: "cat"
                      }, null, 8, _hoisted_76)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.appointment_vet_user_id > 0 && !_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.$t('Customer.ImYourSpecialist')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("figure", _hoisted_83, [
                              _createElementVNode("img", {
                                class: "is-rounded",
                                src: _ctx.specialistProfileImageURL,
                                alt: "no_profile_image"
                              }, null, 8, _hoisted_84)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("p", _hoisted_86, _toDisplayString(_ctx.requestedVetData[0].name), 1),
                            _createElementVNode("p", _hoisted_87, _toDisplayString(_ctx.$t('Customer.LetsSolveTogether')), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getSchedulingAppointment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      (_ctx.isLoadingPaymentForm)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                            _createElementVNode("div", _hoisted_90, [
                              _hoisted_91,
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('Customer.WaitForPayment')), 1),
                                _hoisted_93
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("iframe", {
                            key: 1,
                            id: "AppointmentScheduler",
                            src: _ctx.iframeSrc,
                            class: "scheduler-container",
                            style: {"padding":"0","overflow-y":"hidden","overflow-x":"hidden"}
                          }, null, 8, _hoisted_94))
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}